import { Message } from '../types/message';
import { MessageInput } from '../types/messageInput';

export interface CreateMessageResponse {
  createMessage: Message;
}

export interface CreateMessageVariables {
  input: MessageInput;
}

export const createMessageMutation = `
  mutation CreateMessage($input: MessageInput!) {
    createMessage(input: $input) {
      subscriptionKey
      id
      chatId
      senderId
      receiverId
      text
      createdAt
    }
  }
`;
